import axios from '../../axios/axios';
import ipAddress from '../../axios/ipAddress' //域名
import QS from 'qs'; //序列化

/**
 * 单页面
 */
const privacy = {

   //添加优惠券
   getPrivacyPolicy(){
        return axios.post('http://shine.qiouou.com:9001/customer/c1/privacy-policy/getPrivacyPolicy',null,false)
    },

}
export default privacy;


// WEBPACK FOOTER //
// ./src/js/privacy/privacy.js